import type { RouteObject } from 'react-router';

import { AuthLayout } from '@/features/auth/auth-layout';

import { UnsubscribePage } from './unsubscribe-page';

/** An email's unsubscribe link, in the auth screens' shell and behind no guard. */
export const unsubscribeRoute: RouteObject = {
  element: <AuthLayout />,
  children: [{ path: 'unsubscribe', element: <UnsubscribePage /> }],
};
